const pt_messages = require('./pt/messages.json')

const PORTUGUESE_STRINGS = {
  translation: pt_messages
}

export default PORTUGUESE_STRINGS
